import React, { useEffect, useRef, useState } from 'react';
import { FiSearch, FiChevronDown, FiX } from 'react-icons/fi';

export default function SkillPicker({ selected, onChange, disabled, options, idPrefix = 'skill', singular = 'skill', plural = 'skills' }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const picker = useRef(null);
    const trigger = useRef(null);
    const selectAll = useRef(null);
    const visible = options.filter(skill => skill.toLowerCase().includes(search.trim().toLowerCase()));
    const visibleSelected = visible.filter(skill => selected.includes(skill)).length;
    const allSelected = visible.length > 0 && visibleSelected === visible.length;

    useEffect(() => {
        if (selectAll.current) selectAll.current.indeterminate = visibleSelected > 0 && visibleSelected < visible.length;
    }, [visibleSelected, visible.length, open]);

    useEffect(() => {
        if (!open) return undefined;
        const closeOutside = event => {
            if (!picker.current?.contains(event.target)) { setOpen(false); setSearch(''); }
        };
        document.addEventListener('pointerdown', closeOutside);
        return () => document.removeEventListener('pointerdown', closeOutside);
    }, [open]);

    const close = () => { setOpen(false); setSearch(''); trigger.current?.focus(); };
    const toggle = skill => onChange(selected.includes(skill) ? selected.filter(value => value !== skill) : [...selected, skill]);
    return <div className="crm-skill-picker" ref={picker} onKeyDown={event => {
        if (event.key === 'Escape' && open) { event.preventDefault(); event.stopPropagation(); close(); }
    }}>
        <button type="button" id={`${idPrefix}-trigger`} ref={trigger} className="crm-skill-trigger" disabled={disabled}
            aria-expanded={open && !disabled} aria-controls={`${idPrefix}-options`} aria-labelledby={`${idPrefix}-label ${idPrefix}-trigger-text`}
            onClick={() => { setOpen(value => !value); setSearch(''); }}>
            <span id={`${idPrefix}-trigger-text`}>{selected.length ? `${selected.length} ${selected.length === 1 ? singular : plural} selected` : `Select ${plural}`}</span>
            <span className="crm-skill-trigger-end">{selected.length > 0 && <b>{selected.length}</b>}<FiChevronDown /></span>
        </button>
        {open && !disabled && <div id={`${idPrefix}-options`} className="crm-skill-panel">
            <div className="crm-skill-search"><FiSearch /><input autoFocus type="search" value={search}
                onChange={event => setSearch(event.target.value)} placeholder={`Search ${plural}...`} aria-label={`Search ${plural}`} /></div>
            <label className="crm-skill-select-all">
                <input ref={selectAll} type="checkbox" checked={allSelected} disabled={!visible.length}
                    onChange={() => onChange(allSelected ? selected.filter(skill => !visible.includes(skill)) : [...new Set([...selected, ...visible])])} />
                <span>Select All ({visible.length})</span>
            </label>
            <div className="crm-skill-options" role="group" aria-label={`Available ${plural}`}>
                {visible.length ? visible.map(skill => <label key={skill} className={selected.includes(skill) ? 'crm-skill-checked' : ''}>
                    <input type="checkbox" checked={selected.includes(skill)} onChange={() => toggle(skill)} /><span title={skill}>{skill}</span>
                </label>) : <p className="crm-skill-empty">No {plural} match your search.</p>}
            </div>
        </div>}
        {!!selected.length && <div className="crm-skill-chips">{selected.slice(0, 2).map(skill => <span key={skill}><span className="crm-skill-chip-text" title={skill}>{skill}</span>
            <button type="button" aria-label={`Remove ${skill}`} onClick={() => toggle(skill)}><FiX /></button>
        </span>)}{selected.length > 2 && <span className="crm-skill-more">+{selected.length - 2} more</span>}</div>}
    </div>;
}

